import React, { useEffect, useState, lazy } from 'react';
import { InterveneActions } from '../../../Services/_actions/Intervene/intervene.actions';
import { useRecoilValue } from 'recoil';
import { callersListAtom, dialerAgentListAtom } from '../../../Services/_states';
import ErrorWrapper from '../../Shared/ErrorWrapper';
import { Box, TextField, Typography, Button } from '@mui/material';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { DIALER_CALL_COPY } from '../../../features/intervene/constants/dialerCallCopy';
const SelectDropdown = lazy(() => import('../../Shared/SelectDropdown'));

export const CallingModal = ({ userDetails }) => {
  const userData = userDetails;
  const actions = InterveneActions();
  const dialerCallerIds = useRecoilValue(callersListAtom);
  const dialerAgents = useRecoilValue(dialerAgentListAtom);
  const [formData, setFormData] = useState({
    destination_number: userData?.phone_number,
    agent_number: '',
    caller_id: '',
  });
  const [errors, setErrors] = useState({});
  const validateForm = () => {
    const error = {};
    if (!formData?.destination_number)
      error['destination_number'] = DIALER_CALL_COPY.errors.destination_number;
    if (!formData?.agent_number)
      error['agent_number'] = DIALER_CALL_COPY.errors.agent_number;
    if (!formData?.caller_id)
      error['caller_id'] = DIALER_CALL_COPY.errors.caller_id;
    setErrors(error);
    return Object.keys(error).length === 0;
  }
  const onSubmit = () => {
    if (validateForm())
      actions.postDialerCall(formData);
  };
  useEffect(() => {
    actions.getCallerIds();
    actions.getDialerAgents();
  }, []);

  useEffect(() => {
    setFormData({ ...formData, destination_number: userData?.phone_number });
  }, [userData]);
  return (
    <Box sx={{ p: 2 }}>
      <TextField
        fullWidth
        label={
          <Typography component="span">
            {DIALER_CALL_COPY.fields.customerNumber.label}
          </Typography>
        }
        placeholder="Enter Mobile Number"
        variant="outlined"
        size="small"
        value={formData?.destination_number || ''}
        disabled={true}
        onChange={(e) => {
          const value = e.target.value.replace(/\D/g, '');
          let mobileError = "";
          if (/[^0-9]/.test(value)) {
            mobileError = "Characters are not allowed";
          }
          setErrors({ ...errors, destination_number: mobileError });
          if (!mobileError) {
            setPhoneNumber(value);
          }
        }}
        error={!!errors['destination_number']}
        helperText={
          errors['destination_number'] || DIALER_CALL_COPY.fields.customerNumber.helper
        }
        inputProps={{
          maxLength: 13,
          inputMode: "numeric",
          pattern: "[0-9]*"
        }}
      />
      <SearchableDropdown
        value={formData?.agent || null}
        onChange={(e) => {
          setFormData({ ...formData, agent_number: e?.follow_me_number, agent: e });
          setErrors({ ...errors, agent_number: '' })
        }}
        label={
          <Typography component="span">
            {DIALER_CALL_COPY.fields.agent.label} <span style={{ color: 'red' }}>*</span>
          </Typography>
        }
        placeholder={DIALER_CALL_COPY.fields.agent.placeholder}
        labelKey={'name'}
        valueKey={'follow_me_number'}
        options={dialerAgents?.data || []}
        error={!!errors['agent_number']}
        errorMessage={errors['agent_number'] || DIALER_CALL_COPY.fields.agent.helper}
        sx={{
          mt: 1,
          '& .MuiInputLabel-root.MuiInputLabel-shrink': {
            top: '-2.9px !important'
          },
          '& .MuiFormLabel-root.MuiInputLabel-root': {
            top: '0px'
          }
        }}

      />
      <SearchableDropdown
        sx={{
          mt: 1,
          '& .MuiInputLabel-root.MuiInputLabel-shrink': {
            top: '-2.9px !important'
          },
          '& .MuiFormLabel-root.MuiInputLabel-root': {
            top: '0px'
          }
        }}
        value={formData?.tollFree || null}
        onChange={(e) => {
          setErrors({ ...errors, caller_id: '' });
          setFormData({ ...formData, caller_id: e?.tollfree_number, tollFree: e })
        }}
        label={
          <Typography component="span">
            {DIALER_CALL_COPY.fields.callFrom.label} <span style={{ color: 'red' }}>*</span>
          </Typography>
        }
        placeholder={DIALER_CALL_COPY.fields.callFrom.placeholder}
        error={!!errors['caller_id']}
        errorMessage={errors['caller_id'] || DIALER_CALL_COPY.fields.callFrom.helper}
        labelKey={'tollfree_number'}
        valueKey={'id'}
        options={dialerCallerIds || []}
      />
      <Box display="flex" justifyContent="flex-end" mt={2}>
        {/* <Button variant="outlined" size='small' onClick={() => onClose("", "")} sx={{ mr: 1 }}>Cancel</Button> */}
        <Button variant="contained" size='small' onClick={(e) => {
          onSubmit();
        }}
        >{DIALER_CALL_COPY.actions.submit}</Button>
      </Box>

      {/* <Form>
        <Row>
          <Form.Group className="mb-3" controlId="EditArea">
            <Form.Label>
              Phone Number <span className="required-field">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              defaultValue={formData?.destination_number}
              disabled={true}
              placeholder="1234567890"
              isInvalid={errors['destination_number']}
            />
            {errors['destination_number'] && <ErrorWrapper error={errors['destination_number']} />}
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Select Agent <span className="required-field">*</span>
            </Form.Label>
            <SelectDropdown
              optionsData={dialerAgents?.data}
              selectedValue={formData?.agent}
              placeholder="Select Agent"
              label="Select Agent"
              id="selectAgent"
              OptionLabel={'name'}
              OptionValue={'follow_me_number'}
              handleSelect={(e) => {
                setFormData({ ...formData, agent_number: e?.follow_me_number, agent: e });
                setErrors({ ...errors, agent_number: '' })
              }
              }
            />
            {errors['agent_number'] && <ErrorWrapper error={errors['agent_number']} />}
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Select Number <span className="required-field">*</span>
            </Form.Label>
            <SelectDropdown
              optionsData={dialerCallerIds}
              selectedValue={formData.tollFree}
              placeholder="Select Number"
              label="Select Number"
              id="SelectNumber"
              OptionLabel={'tollfree_number'}
              OptionValue={'id'}
              handleSelect={(e) => {
                setErrors({ ...errors, caller_id: '' });
                setFormData({ ...formData, caller_id: e?.tollfree_number, tollFree: e })
              }
              }
            />
            {errors['caller_id'] && <ErrorWrapper error={errors['caller_id']} />}
          </Form.Group>
          <Col sm={12}>
            <Button
              variant="primary"
              onClick={(e) => {
                onSubmit();
              }}
            >
              Submit
            </Button>
          </Col>
        </Row>
      </Form> */}
    </Box>
  );
};
